/**
 * @generated SignedSource<<dd7d83cf348140f49d2964879324d939>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "has55Plus",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasJuniors",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasMen",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSeniors",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasWomen",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organisationId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rankingType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useOnlyCategories",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": "start_date"
  },
  {
    "kind": "Literal",
    "name": "sortDirection",
    "value": "asc"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "RankingTournament",
  "kind": "LinkedField",
  "name": "rankingTournaments",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Tournament",
      "kind": "LinkedField",
      "name": "tournament",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "rankingTournaments(sortBy:\"start_date\",sortDirection:\"asc\")"
},
v16 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "RankingTournament",
  "kind": "LinkedField",
  "name": "rankingTournaments",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Tournament",
      "kind": "LinkedField",
      "name": "tournament",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v9/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "rankingTournaments(sortBy:\"start_date\",sortDirection:\"asc\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RankingContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Ranking",
        "kind": "LinkedField",
        "name": "ranking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Ranking",
            "kind": "LinkedField",
            "name": "ranking",
            "plural": false,
            "selections": [
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RankingContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Ranking",
        "kind": "LinkedField",
        "name": "ranking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Ranking",
            "kind": "LinkedField",
            "name": "ranking",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "10b98e72ccdb2e1a7ff9adc698f5723e",
    "id": null,
    "metadata": {},
    "name": "RankingContainerQuery",
    "operationKind": "query",
    "text": "query RankingContainerQuery(\n  $id: ID!\n) {\n  ranking(id: $id) {\n    __typename\n    databaseId\n    has55Plus\n    hasJuniors\n    hasMen\n    hasSeniors\n    hasWomen\n    name\n    organisationId\n    rankingType\n    useOnlyCategories\n    ranking {\n      rankingTournaments(sortBy: \"start_date\", sortDirection: \"asc\") {\n        id\n        tournament {\n          databaseId\n          name\n          id\n        }\n      }\n      id\n    }\n    rankingTournaments(sortBy: \"start_date\", sortDirection: \"asc\") {\n      id\n      tournament {\n        databaseId\n        name\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "984fc0c798ec6f977e7a8ffb399507dc";

module.exports = node;
